import React, { ReactElement, createContext, useContext } from 'react';

import InitialData from './InitialData';
import { ShellContextData } from './types';

export const ShellContext = createContext<ShellContextData>(InitialData);

/** This provider should be used in shell apps and not micro apps */
export const ShellContextProvider = ({
  shellData,
  children,
}: {
  shellData: ShellContextData;
  children: React.ReactNode;
}): ReactElement => {
  return (
    <ShellContext.Provider value={shellData}>{children}</ShellContext.Provider>
  );
};

/** @deprecated use ShellContextProvider for shell apps or use [Web/Native]ShellAppProviders for micro apps for the respective platforms */
export const WebShellContextProvider = ShellContextProvider;

export const useShellContext = (): ShellContextData => useContext(ShellContext);
